import useApi from '../hooks/useApi';
import { StaggerReveal, StaggerItem } from './ScrollReveal';

const ArticleCard = ({ libelle, description, visuel_url, tarif, url_paiement, epuise }) => (
  <StaggerItem>
    <div className="card-minimal overflow-hidden flex flex-col group hover:-translate-y-0.5 transition-transform duration-300">
      <div className="relative h-52 bg-stone-50 overflow-hidden flex items-center justify-center p-4">
        {Boolean(epuise) && (
          <span className="absolute top-3 left-3 z-10 text-[11px] font-semibold px-2.5 py-1 rounded-full bg-stone-900 text-white">
            Épuisé
          </span>
        )}
        {visuel_url ? (
          <img src={visuel_url} alt={libelle} className={`h-full w-full object-contain transition-transform duration-500 group-hover:scale-105 ${epuise ? 'opacity-40 grayscale' : ''}`} />
        ) : (
          <div className="w-16 h-16 rounded-2xl bg-stone-100 flex items-center justify-center text-stone-300">
            <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1 gap-3">
        <h3 className="font-semibold text-stone-950 text-sm leading-snug">{libelle}</h3>
        {tarif && <p className="text-sm font-bold text-brand-800">{tarif}</p>}
        <p className="text-xs text-stone-500 leading-relaxed flex-1 line-clamp-4">{description}</p>
        {epuise ? (
          <span className="text-xs font-medium text-stone-400 py-2 px-4 self-start mt-auto rounded-full bg-stone-100">
            Article épuisé
          </span>
        ) : url_paiement && (
          <a href={url_paiement} target="_blank" rel="noopener noreferrer" className="btn-brand text-xs py-2 px-4 self-start mt-auto">
            Procéder au paiement
          </a>
        )}
      </div>
    </div>
  </StaggerItem>
);

const ListeArticles = () => {
  const { data: articles, loading } = useApi('boutique');

  if (loading) return <div className="py-12 text-center text-stone-400 text-sm">Chargement…</div>;
  if (!articles.length) return <p className="text-stone-400 text-sm text-center py-8">Aucun article disponible pour le moment.</p>;

  return (
    <StaggerReveal className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {articles.map(a => <ArticleCard key={a.id} {...a} />)}
    </StaggerReveal>
  );
};

export default ListeArticles;
